import React from "react"
import PropTypes from "prop-types"

import WritingLanguageChoices from '../weekly_writing_prompts/WritingLanguageChoices'
import WritingResponse from '../weekly_writing_prompts/WritingResponse'

class ProfileWeeklyWriting extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedLanguage: '',
      selectedIndex: 0,
      selectedTopics: [],
      allTopics: [],
    }

    this.clickButton = this.clickButton.bind(this)
    this.decreaseIndex = this.decreaseIndex.bind(this)
    this.increaseIndex = this.increaseIndex.bind(this)
    this.renderLeftArrow = this.renderLeftArrow.bind(this)
    this.renderRightArrow = this.renderRightArrow.bind(this)
  }

  componentWillMount() {

    $.ajax({
      url: `../profile_weekly_writing_practice`,
      dataType: 'JSON',
      type: 'POST',
      data: {
        userSlug: this.props.userSlug
      },
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          allTopics: data.data.responses,
          responses: data.data.responses,
          currentUser: data.data.current_user,
          languages: data.data.languages,
        })
        return
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  clickButton(lang) {
    this.setState({
      selectedLanguage: lang.id,
      selectedIndex: 0,
      selectedTopics: this.state.allTopics.filter(function(i) {return i["language_id"] === lang.id})
    })
  }

  renderTopics() {
     if(this.state.selectedLanguage === '') {
       return this.state.responses.map((responses,index) => {
         if(this.state.selectedIndex === index) {
           return (
             <div key={index} style={{textAlign: 'center'}}>
               {responses.writing_topic != null && <h5 style={{color: '#03A9F4', fontWeight: 600, textAlign: 'center'}}>{responses.writing_topic.title}</h5>}
               <WritingResponse response={responses} clapLottie={this.props.clapLottie} clapIcon={this.props.clapIcon} currentUser={this.state.currentUser} editIcon={this.props.editIcon}/>
             </div>
             )
         }
         return null
       })
    } else {
      if(this.state.selectedTopics.length === 0) {
        return (<div style={{textAlign: 'center', paddingBottom: 12, width: '100%'}}><h4>No responses</h4></div>)
      }
      return this.state.selectedTopics.map((responses,index) => {
        if(this.state.selectedIndex === index) {
          return (
            <div key={index} style={{textAlign: 'center'}}>
              {responses.writing_topic != null && <h5 style={{color: '#03A9F4', fontWeight: 600, textAlign: 'center'}}>{responses.writing_topic.title}</h5>}
              <WritingResponse response={responses} clapLottie={this.props.clapLottie} clapIcon={this.props.clapIcon} currentUser={this.state.currentUser} editIcon={this.props.editIcon}/>
            </div>
            )
        }
        return null
      })
    }
  }

  increaseIndex() {
    this.setState({
      selectedIndex: this.state.selectedIndex+1
    })
  }

  decreaseIndex() {
    this.setState({
      selectedIndex: this.state.selectedIndex-1
    })
  }

  renderLeftArrow() {
    if(this.state.selectedIndex != 0) {
      return(
        <img src={this.props.arrowIcon} style={{marginLeft: 10, height: 40, transform: 'rotate(180deg)'}} onClick={this.decreaseIndex}/>
      )
    }
    return (<div style={{width: 10}}></div>)
  }

  renderRightArrow() {
    if(this.state.selectedLanguage === '' && this.state.selectedIndex+1 < this.state.allTopics.length) {
      return(<img src={this.props.arrowIcon} style={{paddingRight: 10, height: 40}} onClick={this.increaseIndex}/>)
    } else if (this.state.selectedLanguage != '' && this.state.selectedIndex+1 < this.state.selectedTopics.length) {
      return(<img src={this.props.arrowIcon} style={{paddingRight: 10, height: 40}} onClick={this.increaseIndex}/>)
    }
    return (<div style={{width: 10}}></div>)
  }

  render() {
    if(this.state.allTopics.length === 0) {
      return null
    }
    return(
      <div className="wrapper_form_dark dark_blue_wrapper" style={{marginTop: 15, position: 'unset'}}>
        <div style={{borderBottom: '1px solid #03a9f4', paddingTop: 1}}>
          <WritingLanguageChoices
            onClick={this.clickButton}
            languages={this.state.languages}
            onAllClick={() => this.setState({selectedLanguage: '', selectedIndex: 0})}
            selectedLanguage={this.state.selectedLanguage}/>
        </div>
        <div style={{display: 'flex', alignItems: 'center', marginTop: 10}}>
          {this.renderLeftArrow()}
          <div style={{marginRight: 5, width: '100%'}}>
            {this.renderTopics()}
          </div>
          {this.renderRightArrow()}
        </div>
      </div>
    )
  }
}

export default ProfileWeeklyWriting;
